const ssn = {
    ssn : {
        value: "",
        dbqName: "F[0].Page_1[0].SocialSecurityNo\\.[0]"
     },
     docName: {
         value: "",
         dbqName: "F[0].Page_10[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "F[0].Page_10[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "F[0].Page_10[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "F[0].Page_10[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "F[0].Page_10[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "F[0].Page_10[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "F[0].Page_10[0].TextField8[5]"
    },
    diagnosisDate : [            
        {
            type: "text",
            dbqName: "F[0].Page_2[0].Diagnosis1[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis[2]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_2[0].Diagnosis2[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis[1]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_2[0].Diagnosis3[0]",
            dateDbqName: "F[0].Page_2[0].DateOfDiagnosis[0]",
        },       
    ]

}

export default ssn ;